<template>
    <OrdersList/>
</template>

<script>
import OrdersList from '../../components/orders/OrdersList';

export default {
  components: {
    OrdersList,
  },
};
</script>
